<template>
  <div class="col col-md-12 p-0">
    <div id="photodoku">
      <div class="innerdoc template2">
         <span class="float-left">
          <img src="@/assets/images/tmp1.jpg" class="mb-3" alt="img" v-if="theme.basics.show_logos == '1' && theme.basics.show_left_logo =='1'">
        </span>
        <span class="float-right">
          <img src="@/assets/images/tmp1.jpg" class="mb-3" alt="img" v-if="theme.basics.show_logos == '1' && theme.basics.show_right_logo =='1'">
        </span>
        <div class="clearfix"></div>
        <div class="picdetail">
          <div class="text-center">
            <ckeditor type="inline" v-model="textPageTwoContent.contents[0].content"/>
            <ckeditor :config="config"  v-model="textPageTwoContent.contents[1].content"/>
          </div>
          <p class="text-center border-top pt-1">
            projectdocu.com
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import CKEditor from 'ckeditor4-vue'
export default {
  data () {
    return {
      config: {
        toolbarGroups: [
          { name: 'clipboard', groups: [ 'clipboard', 'undo' ] },
          { name: 'editing', groups: [ 'find', 'selection', 'spellchecker' ] },
          { name: 'links' },
          { name: 'insert' },
          { name: 'forms' },
          { name: 'tools' },
          { name: 'document', groups: [ 'mode', 'document', 'doctools' ] },
          { name: 'others' },
          '/',
          { name: 'basicstyles', groups: [ 'basicstyles', 'cleanup' ] },
          { name: 'paragraph', groups: ['position', 'list', 'indent', 'blocks', 'align', 'bidi' ] },
          { name: 'styles' },
          { name: 'colors' },
          { name: 'about' }
        ]
      }
    }
  },
  components: {
    ckeditor: CKEditor.component
  },
  computed: {
    theme () {
      return this.$store.state.photoDocumentation.selectedTemplate
    },
    textPageTwoContent () {
      return this.$store.state.photoDocumentation.textPageTwoContent
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/photoDocumentation/components/TextareaTwoTab.vue